export enum ReportsListEciMode {
  FM = 'fm',
  ZM = 'zm',
  LC_NO_PASS = 'lc-no-pass',
  FM_OPEN = 'fm-open',
  OPEN = 'open'
}
